<template>
    <v-dialog :max-width="Modal.Prompt.larguraMaxima" v-model="deveMostrarModalDesempateManual" persistent>
        <v-card :max-width="Modal.Prompt.larguraMaxima" :min-width="Modal.Prompt.larguraMinima">
            <v-card-title primary-title class="primary modal-title">
                <span class=""> Resolver Desempate do {{ value.descricao }}</span>
                <v-spacer></v-spacer>
                <v-icon color="white" @click.stop="cancelarAcaoEFecharModal">close</v-icon>
            </v-card-title>
            <v-card-text>
                <v-container grid-list-md style="background-color: white !important;">
                    <v-layout row wrap>
                        <v-flex xs12>
                            <div>
                                <v-tabs v-model="active_tab" style="border-bottom: 1px solid #efefef;">
                                    <v-tabs-slider color="secondary" style="left: 0; min-width: 170px !important;"></v-tabs-slider>
                                    <v-tab v-for="item in tabs" :key="item.id" ripple
                                           class="text-xs-left"
                                           style="min-width: 170px !important; max-width: 200px !important;"
                                           active-class="primary--text text--darken-2 font-weight-bold tab-active-background">
                                        {{ item.name }}
                                    </v-tab>
                                </v-tabs>

                                <v-tabs-items v-model="active_tab">
                                    <v-tab-item :key="0" class="mt-4" active-class="primary--text font-weight-bold">
                                        <v-data-table
                                            hide-actions
                                            :headers="headers"
                                            :items="fornecedoresEmDesempate"
                                            item-key="raningId"
                                        >
                                            <template v-slot:items="props">
                                                <tr :key="props.item.rankingId">
                                                    <td>{{ posicaoEmpate + props.index}} º</td>
                                                    <td>
                                                        <v-select :items="fornecedoresEmDesempate"
                                                                  item-text="razaoSocial"
                                                                  item-value="rankingId"
                                                                  item-key="rankingId"
                                                                  :item-disabled="item => Object.values(classificacoes).some(fornecedor => fornecedor.rankingId === item.rankingId)"
                                                                  :name="`${posicaoEmpate + props.index}° lugar`"
                                                                  :key="`${posicaoEmpate + props.index}°-lugar`"
                                                                  v-model="classificacoes[posicaoEmpate + props.index]" return-object
                                                                  placeholder="Selecione" single-line
                                                                  class="required-field" v-validate="'required'"
                                                                  :error-messages="errors.collect(`${posicaoEmpate + props.index}° lugar`)">
                                                        </v-select>
                                                    </td>
                                                </tr>
                                            </template>
                                            <template v-slot:footer>
                                                <tr>
                                                    <td colspan="2" class="text-xs-right py-2 px-0 ma-0">
                                                    <v-spacer/>
                                                        <v-btn flat color="primary" @click="classificacoes = {}"
                                                               :disabled="Object.values(classificacoes).length === 0">
                                                            Limpar
                                                        </v-btn>
                                                    </td>
                                                </tr>
                                            </template>
                                        </v-data-table>
                                        <div class="py-3">
                                            <v-textarea label="Critérios utilizados para desempate"
                                                        placeholder="Informe Justificativa"
                                                        v-model="justificativa" name="Justificativa" key="Justificativa"
                                                        class="required-field" v-validate="'required|max:1000'" rows="4" auto-grow
                                                        counter="1000" :error-messages="errors.collect('Justificativa')">
                                            </v-textarea>
                                        </div>
                                    </v-tab-item>
                                    <v-tab-item :key="1" class="mt-4" active-class="primary--text font-weight-bold">
                                        <div class="text-xs-center">
                                            <div class="pa-2">
                                                <v-checkbox v-model="declaracaoDessempateAutomatico"
                                                            name="Declaração de Desempate"
                                                            key="Declaração de Desempate"
                                                            color="primary"
                                                            :label="textoDeclaracao"
                                                            :true-value="true"
                                                            :false-value="null"
                                                            v-validate="active_tab === 1 ? 'required' : ''"
                                                            :error-messages="errors.collect('Declaração de Desempate')"></v-checkbox>
                                            </div>
                                            <div>
                                                <v-btn color="primary"
                                                       bottom
                                                       style="width: 16rem !important; height: 8rem !important;"
                                                       @click.stop="processarDesempatePorSorteio"
                                                       :disabled="declaracaoDessempateAutomatico !== true"
                                                       class="pa-3 botao-sorteio">
                                                    <v-icon size="50" class="mb-2">fa-thin fa-dice</v-icon>
                                                    <br/>
                                                    Sortear
                                                </v-btn>
                                            </div>
                                        </div>
                                    </v-tab-item>
                                </v-tabs-items>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
            <v-card-actions class="px-3 py-2">
                <v-btn flat outline color="botao-cancelar-color" @click.stop="cancelarAcaoEFecharModal">Cancelar</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" depressed v-if="active_tab === 0" @click.stop="processarDesempate">Confirmar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import { Modal } from '@/core/constants'

export default {
    name: 'ModalDesempateManualAutomatico',
    inject: ['$validator'],
    props: {
        deveMostrarModalDesempateManual: {
            type: Boolean,
            default: false
        },
        value: {
            type: Object,
            default: () => ({
                ranking: []
            })
        },
        posicaoEmpate: {
            type: Number,
            default: 0
        },

    },
    data () {
        return {
            headers: [
                {
                    text: 'Colocação',
                    align: 'left',
                    sortable: false,
                    class: 'primary--text font-weight-bold'
                },
                {
                    text: 'Fornecedor',
                    align: 'left',
                    sortable: false,
                    class: 'primary--text font-weight-bold'
                }
            ],
            classificacoes: {},
            justificativa: '',
            active_tab: 0,
            tabs: [
                { id: 0, name: 'Critérios do Art. 60' },
                { id: 1, name: 'Automático' },
            ],
            declaracaoDessempateAutomatico: null,
            textoDeclaracao: 'Não foi possível resolver o desempate, de acordo com os critérios do Art. 60 da Lei 14.133/2021, dessa forma será necessário efetuar o sorteio eletrônico.',
            Modal

        }
    },
    computed: {
        fornecedoresEmDesempate() {
            return this.value.ranking
                .filter(ranking => ranking.posicao === this.posicaoEmpate && ranking.status === 'EMPATADO')
        }
    },
    methods: {
        async processarDesempate() {

            if (!(await this.$validator.validateAll()))
                throw new Error('É necessário processar o desempate completamente!')

            if(Object.keys(this.classificacoes).length !== this.fornecedoresEmDesempate.length)
                throw new Error('É necessário classificar todos os fornecedores.')

            const classificacaoFinal = Object.entries(this.classificacoes).map(([key, value]) => {
                return {
                    rankingId: value.rankingId,
                    posicao: key,
                    pessoaId: value.pessoaId,
                }
            })

            this.$emit('confirmar', { justificativa: this.justificativa, classificacoes: classificacaoFinal })
            this.reset()
        },
        async processarDesempatePorSorteio() {
            if (!(await this.$validator.validate('Declaração de Desempate')))
                throw new Error('É necessário marcar a declaração de desempate!')

            const requestData = {
                justificativa: this.textoDeclaracao,
                itemOuLoteId: this.value.id,
                tipo: this.value.tipo
            }
            this.$emit('desempatarPorSorteio', requestData)
            this.reset()
        },
        cancelarAcaoEFecharModal() {
            this.reset()
            this.$emit('cancelar')
        },
        reset(){
            this.classificacoes = {}
            this.justificativa = ''
            this.declaracaoDessempateAutomatico = null
            this.$validator.reset()
        }
    },
    watch: {
        'active_tab'(value) {
            if(value === 0)
                this.declaracaoDessempateAutomatico = null
        }
    }
}
</script>

<style lang="stylus">
.v-tab .tab-active-background
        background-color: #f5f5f5 !important

.botao-sorteio .v-btn__content
    display block !important
</style>